import { Col, Row, Tooltip } from "antd";
import { Button, Empty } from "antd-v5";
import React, { useState } from "react";
import EqButton from "../../custom/eqButton/EqButton";
import { getDefaultImage, imageType } from "../../shared/Common";
import "./TrainerDashboardInvitations.scss";
import { useTranslation } from "react-i18next";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { IEqUiEventInvite, IEqUiProfile } from "../../shared/interfaces/IEqEventDto";

interface StudentEventInvite {
    id: string;
    firstName: string;
    lastName: string;
    userName: string;
    userImage: string;
    numberOfInvitations: number;
}
interface SchoolPendings {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
}
interface CardProps {
    TrainingInvitratoin?: IEqUiEventInvite[];
    SchoolPenInvitation?: IEqUiProfile[];
    onRejectProduct?: (arg: object) => void;
    onAcceptSchoolInvite?: (arg: object) => void;
    onRejectSchoolInvite?: (arg: object) => void;
    onAcceptTrainingInvitations?: (arg: object) => void;
    onRejectTrainingInvite?: (arg: object) => void;
    onAcceptTrainer?: (arg: object) => void;
    onRejectTrainer?: (arg: object) => void;
    onAcceptProductClick?: (arg: object) => void;
}

const TrainerInvitationCard: React.FC<CardProps> = (
    {
        TrainingInvitratoin,
        SchoolPenInvitation,
        onAcceptSchoolInvite,
        onRejectSchoolInvite,
        onAcceptTrainingInvitations,
        onRejectTrainingInvite,
    }) => {
    const { t } = useTranslation();

    console.log("The Training Invitations are", TrainingInvitratoin);
    const [selectedTab, setSelectedTab] = useState<string>("Training");
    const [showAllTraining, setShowAllTraining] = useState(false);
    const [showAllCourse, setShowAllCourse] = useState(false);
    const [showAllSchool, setShowAllSchool] = useState(false); 
    const [showAll, setShowAll] = useState(false);
    const displaySchool = showAllSchool ? SchoolPenInvitation : SchoolPenInvitation?.slice(0, 3);
    const allEventsWithOrganizer = TrainingInvitratoin?.flatMap((invitation: any) =>
        invitation.events.map((event: any) => ({ ...event, organizer: invitation.organizer }))
    ) || [];
    const displayedTraining = showAllTraining ? allEventsWithOrganizer : allEventsWithOrganizer.slice(0, 3);

    return (
        <div className="trainer-dash-invitations">
            <div className="card-header">
                <h3>{t("invitations")}</h3>
            </div>
            <Row className="card-tab">
                <Col
                    className={`training-tab ${selectedTab === "Training" ? "selected" : ""}`}
                    onClick={() => setSelectedTab("Training")}
                >
                    {t("trainingRequests")}
                </Col>
                <Col
                    className={`training-tab ${selectedTab === "School" ? "selected" : ""}`}
                    onClick={() => setSelectedTab("School")}
                >
                    {t("schoolInvitations")}
                </Col>
            </Row>

            <div className="card-body">
                {selectedTab === "Training" ? (
                     <>
                     {TrainingInvitratoin && TrainingInvitratoin.length > 0 ? (
                         <>
                             {displayedTraining.length > 0 && (
                                 <>
                                     {displayedTraining.map((event: any) => (
                                         <div key={event.id} className="invitation-item">
                                             <Row justify="space-between" style={{ alignItems: "center" }}>
                                             <Tooltip placement="topLeft" title={event.event.title}>
                                                
                                                 <Col span={20}>
                                                     <Row style={{ alignItems: "center" }}>
                                                         <Col>
                                                             <div className="cover-div">
                                                                 <img
                                                                     src={event.user?.userImage?.url || getDefaultImage(imageType.events)}
                                                                     alt="Sender"
                                                                     className="product-image"
                                                                 />
                                                             </div>
                                                         </Col>
                                                         <Col>
                                                             <div className="invitation-title">{event.user.firstName} {event.user.lastName}</div>
                                                             <div>{new Date(event.event?.startTime).toLocaleString()}</div>
                                                         </Col>
                                                     </Row>
                                                 </Col>
                                                 </Tooltip>
                                                 <Col span={4} className="action-col">
                                                    
                                                     <Button
           onClick={() =>onAcceptTrainingInvitations &&  onAcceptTrainingInvitations(event)}
           className="invite-accept-btn"
           size="small"
           shape="circle"
           icon={<CheckOutlined />}
         />
         <Button
           onClick={() =>onRejectTrainingInvite &&  onRejectTrainingInvite(event)}
           className="invite-reject-btn"
           size="small"
           shape="circle"
           icon={<CloseOutlined />}
         />
                                                
                                                </Col>
                                             </Row>
                                         </div>
                                     ))}
                                 </>
                             )}

                             {(TrainingInvitratoin?.reduce((acc: any, invitation: any) => acc + (invitation.events?.length || 0), 0) > 3) && (
                                 <h3 className="showAll-click" onClick={() => setShowAllTraining(!showAllTraining)}>
                                     {showAllTraining ? t("showLess") : t("showAll")}
                                 </h3>
                             )}
                         </>
                     ) : (
                         <Empty description={t("noDataAvailable")}></Empty>
                     )}
                 </>
                ) : selectedTab === "School" ? (
                    // Check if SchoolPenInvitation exists and has items
                    SchoolPenInvitation && SchoolPenInvitation?.length > 0 ? (
                        <>
                            <div className="connection-section">
                                {displaySchool?.map((item: any) => (
                                    <div key={item.id} className="invitation-item">
                                        <Row style={{alignItems: "center"}}>
                                            <Col span={20}>
                                            <Row style={{alignItems: "center"}} >
                                                <Col> <img
                                                src={item?.userImage?.url || getDefaultImage(imageType.trainer)}
                                                alt="Sender"
                                                className="product-image"
                                            /></Col>
                                                <Col>
                                                <div className="invitation-title">{item.firstName} {item.lastName}</div>
                                            <div className="invitation-from">{item.email}</div>
                                                </Col>


                                            </Row>
                                            </Col>
                                              <Col span={4} className="action-col">
                                                                                                   
                                                                                                    <Button
                                                          onClick={() =>onAcceptSchoolInvite &&  onAcceptSchoolInvite(item)}
                                                          className="invite-accept-btn"
                                                          size="small"
                                                          shape="circle"
                                                          icon={<CheckOutlined />}
                                                        />
                                                        <Button
                                                          onClick={() =>onRejectSchoolInvite &&  onRejectSchoolInvite(item)}
                                                          className="invite-reject-btn"
                                                          size="small"
                                                          shape="circle"
                                                          icon={<CloseOutlined />}
                                                        />
                                                                                               
                                                                                               </Col>

                                        </Row>
                                        {/* <div className="cover-div">
                                            <img
                                                src={item?.userImage?.url || getDefaultImage(imageType.trainer)}
                                                alt="Sender"
                                                className="product-image"
                                            />
                                            <div className="invitation-title">{item.firstName} {item.lastName}</div>
                                            <div className="invitation-from">{item.email}</div>
                                            <Col className="action-col">
                                                <EqButton onClick={() => onAcceptSchoolInvite && onAcceptSchoolInvite(item)}>{t("accept")}</EqButton>
                                                <EqButton onClick={() => onRejectSchoolInvite && onRejectSchoolInvite(item)}>{t("reject")}</EqButton>
                                            </Col>
                                        </div> */}
                                    </div>
                                ))}
                            </div>
                            {SchoolPenInvitation?.length > 3 && (
                                <h3 className="showAll-click" onClick={() => setShowAllSchool(!showAllSchool)}>
                                    {showAllSchool ? t("showLess") : t("showAll")}
                                </h3>
                            )}
                        </>
                    ) : (
                        <Empty description={t("noDataAvailable")}></Empty>
                    )
                ) : (
                    <Empty description={t("noDataAvailable")}></Empty>
                )}
            </div>
        </div>
    );
};
export default TrainerInvitationCard;